export default __webpack_public_path__ + "static/media/previousDues.1fca9c11.svg";